import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  constructor(private msal: MsalService) {}

  get activeAccount() {
    return this.msal.instance.getActiveAccount();
  }

  get isLoggedIn(): boolean {
    return !!this.activeAccount;
  }

  get roles(): string[] {
      const claims = (this.activeAccount?.idTokenClaims ?? {}) as any;
      return (claims.roles ?? []).map((r: string) => r.toLowerCase());
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role.toLowerCase());
  }

  get tenantId(): string | null {
    const claims = (this.activeAccount?.idTokenClaims ?? {}) as any;
    return claims.tid ?? null;
  }

  get groupIds(): string[] {
    const claims = (this.activeAccount?.idTokenClaims ?? {}) as any;
    return claims.groups ?? [];
  }

  hasGroup(groupId: string): boolean {
    return this.groupIds.includes(groupId);
  }

}
